import React, { useEffect, useState } from 'react'
import { StyledCard, CardStyleProps } from './card.styles'

export interface CardProps
    extends CardStyleProps,
        React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode
    className?: string
}

export const Card: React.FC<CardProps> = ({
    children,
    variant = 'default',
    padding = 'medium',
    fullWidth = false,
    className,
    ...props
}) => {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        // Small delay to ensure component is fully mounted
        const timer = setTimeout(() => setIsVisible(true), 10)
        return () => clearTimeout(timer)
    }, [])

    const { popover, ...safeProps } = props

    return (
        <StyledCard
            variant={variant}
            padding={padding}
            fullWidth={fullWidth}
            className={className}
            style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0)' : 'translateY(8px)',
            }}
            {...safeProps}
        >
            {children}
        </StyledCard>
    )
}
